module.exports = __webpack_public_path__ + "img/bg@2x.d344e1b5.png";